import React from 'react';
import './CognitiveGap.css';
import { useLanguage } from '../contexts/LanguageContext';

// Bu bileşen, ortalanmış bir düzen içinde bir simge, başlık ve metin içeren
// şık bir kart görüntüler. Tailwind CSS sınıfları stil için kullanılır.

// Ana CognitiveGap Bileşeni
const CognitiveGap = () => {
  const { t } = useLanguage();
  
  const cards = [
    {
      image: '/images/site-gorselleri-efektli/1.PNG',
      titleKey: 'cognitiveGap.cards.0.title',
      descriptionKey: 'cognitiveGap.cards.0.description'
    },
    {
      image: '/images/site-gorselleri-efektli/2.PNG',
      titleKey: 'cognitiveGap.cards.1.title',
      descriptionKey: 'cognitiveGap.cards.1.description'
    },
    {
      image: '/images/site-gorselleri-efektli/3.PNG',
      titleKey: 'cognitiveGap.cards.2.title',
      descriptionKey: 'cognitiveGap.cards.2.description'
    }
  ];



  return (
    <section className="cognitive-gap" id="problem">
      <div className="container">
        <h2 className="section-title">{t('cognitiveGap.title')}</h2>
        <p className="section-description">
          {t('cognitiveGap.description')}
        </p>
        
        {/* Kartlar Grid Yapısı */}
        <div className="cards-grid">
          {cards.map((card, index) => (
            <div key={index} className="card">
              <div className="card-icon">
                <img src={card.image} alt={t(card.titleKey)} />
              </div>
              <h3 className="card-title">{t(card.titleKey)}</h3>
              <p className="card-description">{t(card.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CognitiveGap; 